/*
Product Form
*/

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.flavor = "Mint";
    this.cadence = "Once";
    this.variantInput = null;
    this.planInput = null;
  }

  connectedCallback() {
    const variants = document.getElementById("product-variants");

    if (variants) {
      
      const variantsJson =
        document.getElementById("product-variants").innerText;

      this.variants = JSON.parse(variantsJson);

      // console.log("variantsJson", variantsJson); 
      
      this.variantId = this.variants[0].variantId;
      //console.log('InitialVariantIdCitrus-------->',this.variantId);
      this.planId = this.variants[0].planId;
      this.planInput = this.querySelector('input[name="selling_plan"]');
      this.variantInput = this.querySelector('input[name="id"]');
      //console.log('InitialVariantInput-------->',this.variantInput);
    }
  }

  setPlan(planId) {
    this.planId = planId;
    this.planInput.value = planId;
  }

  setPrice(price) {
    const atcPrice = this.querySelector(".atc-price");
    const finalPrice = this.fmtPrice(price);
    atcPrice.innerText = finalPrice;
  }

  fmtPrice(price) {
    const variantPrice = price / 100;
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: Shopify.currency.active,
    });
    return formatter.format(variantPrice).replace(/\.00$/, "");
  }

  setVariant(variantId) {
    this.variantId = variantId;
    this.variantInput.value = variantId;
    //console.log(this.variantInput.value);
    //console.log(this.variantInput);
  }
}

customElements.define("product-form", ProductForm);

/*
Flavor Selector
*/

class FlavorSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const button = e.target.closest("button");
      const flavor = button ? button.dataset.flavor : null;
      const title = button ? button.dataset.variantTitle : null;

      this.updateButtonStyles(button);
      this.updateFlavorElements(flavor);
      this.updateWholesale(flavor);
      this.activateSelected(flavor);
    });
  }

  updateWholesale(flavor) {
    const form = this.closest("product-form");
    form.querySelectorAll("[data-wholesale-flavor]").forEach((el) => {
      el.classList.add("hidden");
    });
    const match = form.querySelector(`[data-wholesale-flavor="${flavor}"]`);
    if (match) {
      match.classList.remove("hidden");
    }
  }

  updateButtonStyles(activeButton) {
    this.querySelectorAll("button").forEach((button) => {
      button.classList.remove("active");
    });
    activeButton?.classList.add("active");
  }

  updateFlavorElements(flavor) {
    if (flavor === "Mint") {
      document.querySelectorAll('[data-swap-flavor="Mint"').forEach((el) => {
        el.classList.add("!opacity-100", "z-10");
      });
      document.querySelectorAll('[data-swap-flavor="Citrus"').forEach((el) => {
        el.classList.remove("!opacity-100", "z-10");
      });
    } else {
      document.querySelectorAll('[data-swap-flavor="Mint"').forEach((el) => {
        el.classList.remove("!opacity-100", "z-10");
      });
      document.querySelectorAll('[data-swap-flavor="Citrus"').forEach((el) => {
        el.classList.add("!opacity-100", "z-10");
      });
    }
  }

  activateSelected(flavor) {
    const form = this.closest("product-form");
    
    const cadence = form.cadence;
    
    form.flavor = flavor;
    
    form.querySelectorAll("div[data-cadence]").forEach((cadence) => {
      cadence.classList.add("hidden");
    });
    const cadenceMatches = form
      .querySelectorAll(
        `div[data-cadence="${cadence}"][data-flavor="${flavor}"]`
      )
      .forEach((cadence) => {
        cadence.classList.remove("hidden");

        const active = cadence.querySelector("button.active");
        const variantId = active.dataset.variantId;
        const variantMatch = form.variants.find(
          (variant) => Number(variant.variantId) === Number(variantId)
        );

        if (variantMatch) {
          
          form.setVariant(variantMatch.variantId);

          if (
            variantMatch.sellingPlans.length > 0 &&
            form.cadence == "Subscribe"
          ) {
            const select = cadence.querySelector("select");
            const selectedPlan = select.value;
            
            const activePlan = variantMatch.sellingPlans.find(
              (plan) => plan.name === selectedPlan
            );

            if (activePlan) {
              
              form.setPrice(activePlan.price);
              form.setPlan(activePlan.id);
            }
          } else {
            form.setPrice(variantMatch.variantPrice);
            form.setPlan("");
          }
        }
      });
  }
}

customElements.define("flavor-selector", FlavorSelector);

/*
Variant Selector
*/

class VariantSelector extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const button = e.target.closest("button");
      //console.log(button);
      const title = button.dataset.variantTitle;

      this.updateButtonStyles(button);
      this.updateProductForm(button);
      this.setupSelectListener();
    });
  }

  setupSelectListener() {
    this.querySelectorAll("select").forEach((select) => {
      select.addEventListener("change", (e) => {
        const form = e.target.closest("product-form");
        
        const variantId = e.target.closest("button").dataset.variantId;
        const planName = e.target.value;
        
        
        const variantMatch = form.variants.find(
          (variant) => Number(variant.variantId) === Number(variantId)
        );

        if (variantMatch) {
          const planMatch = variantMatch.sellingPlans.find(
            (plan) => plan.name === planName
          );
          form.setPlan(planMatch.id);
        }
      });
    });
  }

  updateProductForm(button) {
    const form = button.closest("product-form");
    const variantId = button.dataset.variantId;

    form.setVariant(variantId);

    const variantMatch = form.variants.find(
      (variant) => Number(variant.variantId) === Number(variantId)
    );

    if (variantMatch) {
      if (variantMatch.sellingPlans.length > 0 && form.cadence == "Subscribe") {
        const select = button.querySelector("select");
        const selectedPlan = select.value;
        const activePlan = variantMatch.sellingPlans.find(
          (plan) => plan.name === selectedPlan
        );

        if (activePlan) {
          form.setPrice(activePlan.price);
          form.setPlan(activePlan.id);
        }
      } else {
        form.setPrice(variantMatch.variantPrice);
        form.setPlan("");
      }
    }
  }

  updateButtonStyles(activeButton) {
    this.querySelectorAll("button").forEach((button) => {
      button.classList.remove("active");
    });
    activeButton?.classList.add("active");
  }
}

customElements.define("variant-selector", VariantSelector);

/*
Cadence Selector
*/

class CadenceSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      const button = e.target.closest("button");
      
      const cadence = button.dataset.cadence;
      //console.log(cadence)
      this.updateButtonStyles(button);
      this.activateSelected(cadence);
    });
  }

  updateButtonStyles(button) {
    this.querySelectorAll("button").forEach((button) => {
      button.classList.remove("active");
    });
    button.classList.add("active");
  }

  activateSelected(cadence) {
    const form = this.closest("product-form");
    //console.log(form)

    
    let currentUrlCheck = window.location.pathname.split('/');

    let urlAfter2 = new URL(window.location.href);
    let searchParamsInitial2 = urlAfter2.search
    let SearchFlavorInitial2 = searchParamsInitial2.includes('flavor=Mint') ? 'Mint' : 'Citrus';

    let CurrentLastPartCheck = currentUrlCheck[currentUrlCheck.length - 1];

    if(CurrentLastPartCheck == "Mint" || CurrentLastPartCheck == "mint" || SearchFlavorInitial2 == "Mint" || SearchFlavorInitial2 == "mint"){
      var flavor = 'Mint';
      //console.log(flavor)
    }else if(CurrentLastPartCheck == "Citrus" || CurrentLastPartCheck == "citrus" || SearchFlavorInitial2 == "Citrus" || SearchFlavorInitial2 == "citrus"){
      var flavor = 'Citrus';
      //console.log(flavor)
    }else{
      var flavor = 'Citrus';
      //console.log(flavor)
    }    
      
    
    // const flavor = form.flavor;
    form.cadence = cadence;

    form.querySelectorAll("div[data-cadence]").forEach((cadence) => {
      cadence.classList.add("hidden");
    });
    const cadenceMatches = form
      .querySelectorAll(
        `div[data-cadence="${cadence}"][data-flavor="${flavor}"]`
      )
      .forEach((cadence) => {
        cadence.classList.remove("hidden");

        const active = cadence.querySelector("button.active");
        const variantId = active ? active.dataset.variantId : null;
        const variantMatch = form.variants.find(
          (variant) => Number(variant.variantId) === Number(variantId)
        );

        if (variantMatch) {
         // console.log(variantMatch.variantId);
          form.setVariant(variantMatch.variantId);

          if (
            variantMatch.sellingPlans.length > 0 &&
            form.cadence == "Subscribe"
          ) {
            const select = cadence.querySelector("select");
            const selectedPlan = select.value;
            const activePlan = variantMatch.sellingPlans.find(
              (plan) => plan.name === selectedPlan
            );

            if (activePlan) {
              form.setPrice(activePlan.price);
              form.setPlan(activePlan.id);
            }
          } else {
            form.setPrice(variantMatch.variantPrice);
            form.setPlan("");
          }
        }
      });
  }
}

customElements.define("cadence-selector", CadenceSelector);

/*
Quantity Selector
*/

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.quantity = 1;
  }

  connectedCallback() {
    this.input = this.closest("[data-wholesale-flavor]").querySelector(
      'cart-add [name="quantity"]'
    );
    this.currQuantity = this.querySelector(".curr-quantity");
    this.addEventListener("click", (e) => {
      this.handleClick(e);
    });
  }

  handleClick(e) {
    e.preventDefault();
    const button = e.target.closest("button");

    if (button) {
      if (button.name === "increment") {
        this.quantity = this.quantity + 1;
      } else {
        if (this.quantity > 1) {
          this.quantity = this.quantity - 1;
        }
      }

      this.input.value = this.quantity;
      this.currQuantity.innerText = this.quantity;
    }
  }
}

customElements.define("quantity-selector", QuantitySelector);

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
  // Get the selling plan input
  const sellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]');
  // Get the price display element in the Add to Cart button
  const atcPriceElement = document.querySelector('.atc-price');
  const citrusOncePanel = document.querySelector('variant-selector div[data-flavor="Citrus"][data-cadence="Once"]');
  const minOncePanel = document.querySelector('variant-selector div[data-flavor="Mint"][data-cadence="Once"]');

  const activeButton = citrusOncePanel?.querySelector('button.active');

  const compareAtPriceElement = activeButton?.querySelector('.new-pr');

  
  // Store the original price from the Once option

  let originalPrice = '';
  if (atcPriceElement) {
    atcPriceElement.innerText = compareAtPriceElement?.innerText;
    originalPrice = atcPriceElement.innerText;
  }
  
  sellingPlanInputs.forEach(input => {
    const originalValue = input.value;
    input.value = '';
  });
  
});
